import { createSlice } from "@reduxjs/toolkit";
import { shareReportWhatsapp } from "@custom/rtk-apis/report/shareReportWhatsapp";
import { initialState } from "@custom/constant";

// interface shareReportState {
//   status: string;
//   result: any; 
//   msg: string;
//   loading: boolean;
//   error: string | null;
// }

// const initialState: shareReportState = {
//   status: "",
//   result: null,
//   msg: "",
//   loading: false,
//   error: null,
// };

const shareReportWhatsappSlice = createSlice({
  name: "shareReportWhatsappSlice",
  initialState,
  reducers: {
    revertStatus: (state) => {
      state.status = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(shareReportWhatsapp.pending, (state) => {
        console.log("Pending");
        state.loading = true;
        state.error = null;
      })
      .addCase(shareReportWhatsapp.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload);
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(shareReportWhatsapp.rejected, (state, action) => {
        console.log("Rejected", action.payload);
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default shareReportWhatsappSlice.reducer;
export const { revertStatus } = shareReportWhatsappSlice.actions;
